export const LEADDELIVERY_API_URL = '/leaddelivery/v2';
export const DIGITAL_RETAIL_URL = `${LEADDELIVERY_API_URL}/digitalretail/`;
